/**
 * OGP wrapper — spaja @belit/accessibility-panel sa projekat-specifičnim fajlovima.
 * @see CUSTOM_SETUP.md
 */

import React from 'react';
import AccessibilityPanel from '@/shared/accessibility-panel';
import { CUSTOM_CONFIG } from './accessibility.custom.config';
import './accessibility.custom.overrides.css';

/** Mountuje `@belit/accessibility-panel` sa OGP custom config i CSS override-ima. */
export default function AccessibilityPanelWrapper() {
  return <AccessibilityPanel config={CUSTOM_CONFIG} />;
}
